import React, { Component } from 'react';
import { GoogleMap, MarkerF, InfoWindow, Autocomplete } from '@react-google-maps/api';
import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { Checkbox } from "@progress/kendo-react-inputs";
import ExpandedPole from "../../global_components/cs_pole_popup";
import loadinggif from "../../assets/loading.gif";
import loadingtext from "../../assets/loadingmaps.png";
import withProject from "../../contexts/class_context_convert.js";
import withTabContext from "../../contexts/report_tab_context_convert.js";
import withHighlightedPoles from "../../contexts/highlighted_poles_class_context_convert.js";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import blackIcon from "../../assets/SymbologyIcons/blackIcon.png";
import selectedBlueIcon from "../../assets/SymbologyIcons/selectedBlue.png";
import selectedBlackIcon from "../../assets/SymbologyIcons/selectedBlack.png";
import selectedRedIcon from "../../assets/SymbologyIcons/selectedRed.png";
import selectedGreenIcon from "../../assets/SymbologyIcons/selectedGreen.png";
import selectedOrangeIcon from "../../assets/SymbologyIcons/selectedOrange.png";
import selectedYellowIcon from "../../assets/SymbologyIcons/selectedYellow.png";
import addressIcon from "../../assets/SymbologyIcons/searchAddressCenterIcon.png";
import validationIcon from "../../assets/SymbologyIcons/ValidationIcon.png";
import getClusterRenderer from '../../global_components/getClusterRenderer.js';

import moment from 'moment'
import { Button } from "@progress/kendo-react-buttons";
import withEnvironmentConfig from '../../contexts/EnvironmentConfigContextClassWrapper';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
// 2. The Box (The "Body")
import { Input } from "@progress/kendo-react-inputs";

// 3. The Text (The "Labeling")
import { Error } from "@progress/kendo-react-labels";
const requiredValidator = (value) =>
    !value ? "This field is required." : "";
const getMapOptions = () => {
    if (window.google && window.google.maps) {
        return {
            fullscreenControl: false,
            styles: [
                {
                    elementType: "labels",
                    featureType: "poi",
                    stylers: [{ visibility: "off" }],
                },
            ],
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: window.google.maps.ControlPosition.TOP_RIGHT,
            },
        };
    }
    return {}; // Fallback if maps is not loaded
};


const containerStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '10px',
    borderColor: '#BFBFBF',
}

const containerStyleFullSize = {
    width: '100%',
    height: '81vh',
    borderRadius: '10px',
    borderColor: '#BFBFBF'
}

const mapSearchOption = ['Pole Number', 'Address'];

const clusterStyles = {
    "closed": getClusterRenderer('rgba(18, 96, 206)'),
    "ready-to-go": getClusterRenderer('rgba(32, 121, 10)'),
    "no-access": getClusterRenderer('rgba(255, 128, 0)'),
    "complex-transfers": getClusterRenderer('rgba(255, 197, 23)'),
    "does-not-exist": getClusterRenderer('rgba(255, 0, 0)'),
    "others": getClusterRenderer(),
};
class CSPoleMap extends Component {
    firstTime = true;

    constructor(props) {
        super(props);
        this.state = {
            mapData: [],
            currentSelectedPole: null,
            currentCenter: {
                lat: 39.87597539,
                lng: -86.06844941
            },
            showInfoWindow: true,
            checkedMaplegend: "No Status",
            originalData: null,
            showDrawer: true,
            showPulled: true,
            showHeavyVegetation: true,
            showPoleNotSet: true,
            showElectricPower: true,
            showPoleNeedsTopping: true,
            showClosed: true,
            showReadyToGo: true,
            showNoAccess: true,
            showComplexTransfers: true,
            showDoesNotExist: true,
            showForeignOwned: true,
            showOthers: true,
            //START MAP DATA
            filteredMapData: [],
            mapDataLoaded: false,
            clusterersInitialized: false,
            closedClusterer: {},
            readyToGoClusterer: {},
            noAccessClusterer: {},
            complexTransfersClusterer: {},
            doesNotExistClusterer: {},
            othersClusterer: {},
            //END MAP DATA
            currentPin: "default",
            loading: true,
            map: {},
            poleadderList: [],
            poleconditionList: [],
            poleauditstatusList: [],
            rawQuery: null,
            created_user: [],
            Reject_Status: [],
            created_user_checkbox: true,
            Reject_Status_checkbox: true,
            checkboxvalue: false,
            dateStart: null,
            dateEnd: null,
            showDate: {},
            counts: 0,
            drawingRec: null,
            lassoWindow: false,
            lassoData: null,
            drawOption: null,
            datevalue: null,
            audit_checkbox: true,
            zoomLevel: 16,
            currentDisplayPole: null,
            searchType: "Pole Number",
            isSearchByAddress: false,
            addressValid: true,
            showErrorMessage: false,
            searchEnteredAddress: "",
            isrecenter: false,
        };
        this.autocomplete = null
        this.onLoad = this.onLoad.bind(this);
        this.onPlaceChanged = this.onPlaceChanged.bind(this);
        this.handleMarkerOnClick = this.handleMarkerOnClick.bind(this);
        this.handleMapOnClick = this.handleMapOnClick.bind(this);
        this.handlePoleonChange = this.handlePoleonChange.bind(this);
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        if (this.props.projectContext.selectedProject !== "") {
            this.populateMapData("");
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {

        const { highlightedPoles } = this.props.highlightedPolesContext;

        /**
         * REMOVED BECAUSE IS UNNECESARY
        // Handle highlighted poles context changes
        if (prevProps.highlightedPolesContext.highlightedPoles !== highlightedPoles) {
            this.updateFilteredMapData();
        }
        */

        if (this.props.projectContext.selectedProject !== prevProps.projectContext.selectedProject) {
            this.populateMapData("");
            this.handleClearMapFilter(false);
        }
    }

    handlePoleonChange(e, type, pinType) {
        if (type === this.state.checkedMaplegend) {
            this.setState({
                checkedMaplegend: "No Status",
                currentPin: "default",
                currentSelectedPole: null,
                loading: true
            }, () => {
                let boundInput = this.getBounds();
            })
        }
        else {
            this.setState({
                checkedMaplegend: type,
                currentSelectedPole: null,
                currentPin: pinType,
                loading: true
            }, () => {
                let boundInput = this.getBounds();
            })
        }

    }

    handleMarkerOnClick(marker, e) {
        // console.log(marker); //02062
        if(marker != null){
            this.setState({
                currentSelectedPole: null,
                currentCenter: null
            }, () => {
                this.setState({
                    currentSelectedPole: marker,
                    currentCenter:marker?.coords
                });
            })
        }
    }

    handleClickOutside(event) {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
        this.setState({ showErrorMessage: false });
        }
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            var searchInput = e.target.value;
            var lookupData = this.state.mapData;
            var test = lookupData.filter(function (data) {
                return lookupData !== null ? data.info.Pole_Number === searchInput : null
            });

            this.setState({
                currentSelectedPole: null,
                zoomLevel: null,
                isSearchByAddress: false,
                currentCenter: null
            }, () => {
                this.setState({
                    currentSelectedPole: test.length === 0 ? null : test[0],
                    zoomLevel : 16,
                    currentCenter: test.length === 0 ? null : test[0]?.coords,
                    isrecenter: !this.state.isrecenter
                });
            })
        }
    }

    handleAddressKeyPress(e) {
        if (e.key === 'Enter') {
            var searchInput = e.target.value;
            console.log(searchInput);
            if (!this.state.map || !searchInput) return;

            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: String(searchInput) }, (results, status) => {
                if (status === "OK") {
                    this.setState({
                        currentCenter: results[0].geometry.location,
                        currentSelectedPole: null,
                        isSearchByAddress: true,
                        addressValid: true,
                        showErrorMessage: false
                    });
                }
                else {
                    this.setState({
                        addressValid: false,
                        searchEnteredAddress: searchInput,
                        isSearchByAddress: false,
                    });
                }
            });
        }
    }

    onPlaceChanged() {
        //251-B110
        if (this.autocomplete !== null) {
            var searchCallback = this.autocomplete.getPlace();
            var searchInput = searchCallback.name.toString();
            if (searchCallback.geometry ?.viewport) {
                this.setState({
                    currentCenter: searchCallback.geometry.location,
                    currentSelectedPole: null,
                    isSearchByAddress: true,
                    addressValid: true,
                    showErrorMessage: false
                });
            }
            else {
                this.setState({
                    isSearchByAddress: false,
                    addressValid: false,
                });
            }
        } else {
            console.log('Autocomplete is not loaded yet!')
            this.setState({
                isSearchByAddress: false,
            });
        }
    }

    handleSearchTypeChange(e) {
        var value = e.target.value;
        console.log(value);
        this.setState({
            searchType: value,
            addressValid: true,
            isSearchByAddress: false,
            showErrorMessage: false
        })
    }


    handleMapOnClick() {
        this.setState({
            currentSelectedPole: null,
        })
    }

    handleDraw() {
        this.setState({
            drawOption: "rectangle",
        })
    }

    handleOffDraw() {
        this.state.drawingRec.setMap(null);
        this.setState({
            drawOption: "maker",
            lassoWindow: false
        })
    }

    onLoad(autocomplete) {
        this.autocomplete = autocomplete
    }

    boundsCallBack = () => {
        setTimeout(() => {
            let boundInput = this.getBounds();
            if (!boundInput) return;
            this.updateFilteredMapData({bounds: boundInput});
        }, 500)
    }

    boundsZoomCallBack = () => {
        setTimeout(() => {
            let boundInput = this.getBounds();
            if (!boundInput) return;
            if (this.state.mapDataLoaded) {
                this.updateFilteredMapData({bounds: boundInput});
            }
        }, 1000)
    }

    findFirstHighlighted = () => {
        const { highlightedPoles } = this.props.highlightedPolesContext;
        const pole = this.state.mapData.find((item) => highlightedPoles.includes(item.info?.GlobalID));
        if (pole) {
            this.setState({
                currentCenter: pole.coords,
                zoomLevel: 16
            }, () => {
                this.updateFilteredMapData({
                    bounds: this.getBounds(),
                    skipHighlighted: true,
                });
                return this.getBounds();
            });
        }
    };
    clearClustererMarkers = () => {
        this.state.filteredMapData.forEach((marker) => {
            window.google.maps.event.clearInstanceListeners(marker);
        });
        this.state.closedClusterer.clearMarkers();
        this.state.readyToGoClusterer.clearMarkers();
        this.state.noAccessClusterer.clearMarkers();
        this.state.complexTransfersClusterer.clearMarkers();
        this.state.doesNotExistClusterer.clearMarkers();
        this.state.othersClusterer.clearMarkers();
    }
    getMarkerClusterer = (map, clusterName) => {
        return new MarkerClusterer({
            map, markers: [], renderer: clusterStyles[clusterName], 
            algorithm: new SuperClusterAlgorithm({
                radius: 120,
                minPoints: 5,
            }), 
        })
    }
    waitMapDataLoaded = async (intervalMs = 200, timeoutMs) => {
        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        const startDate = Date.now();
        while (!this.state.mapDataLoaded) {
            if (Date.now() - startDate > timeoutMs) {
                throw new Error('loading map timed out');
            }
            await delay(intervalMs);
        }
    }
    updateFilteredMapData = async (options) => {
        await this.waitMapDataLoaded()
        
        const addDataToArray = (marker, allFilters, specificFilter) => {
            allFilters.push(marker);
            specificFilter.push(marker);
        };
        const { highlightedPoles } = this.props.highlightedPolesContext;
        const {
            mapData,
            showClosed,
            showPulled,
            showReadyToGo,
            showHeavyVegetation,
            showPoleNotSet,
            showElectricPower,
            showPoleNeedsTopping,
            showNoAccess,
            showComplexTransfers,
            showForeignOwned,
            showDoesNotExist,
            showOthers,
        } = this.state;
        const handledStatuses = [
            "Pulled",
            "Closed",
            "Ready to Go",
            "Heavy Vegetation",
            "Pole Not Set",
            "Electric Power",
            "Pole Needs Topping",
            "No Access",
            "Complex Transfers",
            "Foreign Owned",
            "Does Not Exist",
        ];
        let firstHighlightedBounds;
        if (highlightedPoles.length > 0 && !options?.skipHighlighted && this.firstTime) {
            firstHighlightedBounds = this.findFirstHighlighted();
            this.firstTime = false;
            return;
        }
        if (!firstHighlightedBounds) {
            firstHighlightedBounds = options?.bounds;
        }
        const filteredMapData = {
            allFilters: [],
            closed: [],
            readyToGo: [],
            noAccess: [],
            complexTransfers: [],
            doesNotExist: [],
            others: [],
        };
        const bounds = firstHighlightedBounds ?? this.getBounds();
        this.clearClustererMarkers();

        mapData.forEach((item) => {
            if (item.coords.lat <= bounds.north && item.coords.lat >= bounds.south && item.coords.lng >= bounds.west && item.coords.lng <= bounds.east) {  
                if (highlightedPoles.length > 0 && !highlightedPoles.includes(item.info?.GlobalID)) {
                    return;
                }
                const marker = new window.google.maps.Marker({
                    position: item.coords,
                    icon: item.iconSymbol,
                });
                marker.addListener("click", (event) => {
                    this.handleMarkerOnClick(item, event);
                });
                const status = item.info ?.Pole_Status;
                switch (status) {
                    case 'Pulled':
                    case 'Closed': {
                        if (showClosed || showPulled) {
                            addDataToArray(marker, filteredMapData.allFilters, filteredMapData.closed);
                        }
                        break;
                    }
                    case 'Ready to Go': {
                        if (showReadyToGo) {
                            addDataToArray(marker, filteredMapData.allFilters, filteredMapData.readyToGo);
                        }
                        break;
                    }
                    case 'Heavy Vegetation':
                    case 'Pole Not Set':
                    case 'Electric Power':
                    case 'Pole Needs Topping':
                    case 'No Access': {
                        if (showNoAccess || showHeavyVegetation || showPoleNotSet || showPoleNeedsTopping || showElectricPower) {
                            addDataToArray(marker, filteredMapData.allFilters, filteredMapData.noAccess);
                        }
                        break;
                    }
                    case 'Complex Transfers': {
                        if (showComplexTransfers) {
                            addDataToArray(marker, filteredMapData.allFilters, filteredMapData.complexTransfers);
                        }
                        break;
                    }
                    case 'Foreign Owned':
                    case 'Does Not Exist': {
                        if (showDoesNotExist || showForeignOwned) {
                            addDataToArray(marker, filteredMapData.allFilters, filteredMapData.doesNotExist);
                        }
                        break;
                    }
                    default: {
                        if (showOthers) {
                            addDataToArray(marker, filteredMapData.allFilters, filteredMapData.others);
                        }
                    }
                }
            }
        });
        this.state.closedClusterer.addMarkers(filteredMapData.closed);
        this.state.readyToGoClusterer.addMarkers(filteredMapData.readyToGo);
        this.state.noAccessClusterer.addMarkers(filteredMapData.noAccess);
        this.state.complexTransfersClusterer.addMarkers(filteredMapData.complexTransfers);
        this.state.doesNotExistClusterer.addMarkers(filteredMapData.doesNotExist);
        this.state.othersClusterer.addMarkers(filteredMapData.others);
        this.setState({ filteredMapData: filteredMapData.allFilters });

    };

    //onPlaceChanged() {
    //    //251-B110
    //    if (this.autocomplete !== null) {
    //        var searchCallback = this.autocomplete.getPlace();
    //        var searchInput = searchCallback.name.toString();
    //        var lookupData = this.state.mapData;
    //        var test = lookupData.filter(function (data) {
    //            return lookupData !== null ? data.info.Pole_Number === searchInput : null
    //        });
    //        this.setState({
    //            currentSelectedPole: null,
    //        }, () => {
    //            this.setState({
    //                currentSelectedPole: test.length === 0 ? null : test[0],
    //            });
    //        })
    //    } else {
    //        console.log('Autocomplete is not loaded yet!')
    //    }
    //}

    showDrawer = () => {
        this.setState({
            showDrawer: !this.state.showDrawer
        })
    }

    getBounds = () => {
        let bounds = this.state.map?.getBounds();
        let center = this.state.map?.getCenter();
        if (!bounds || !center) return;

        let lat = center.lat();
        let long = center.lng();

        let ne = bounds.getNorthEast(); // LatLng of the north-east corner
        let sw = bounds.getSouthWest(); // LatLng of the south-west corner

        let bbox = {
            north: ne.lat(),
            east: ne.lng(),
            south: sw.lat(),
            west: sw.lng(),
            lat: lat,
            long: long
        };

        return bbox;
    }

    handleMapLoad = (map) => {
        this.setState((state) => ({ ...state, 
            map, 
            closedClusterer: this.getMarkerClusterer(map, 'closed'),
            readyToGoClusterer: this.getMarkerClusterer(map, 'ready-to-go'),
            noAccessClusterer: this.getMarkerClusterer(map, 'no-access'),
            complexTransfersClusterer: this.getMarkerClusterer(map, 'complex-transfers'),
            doesNotExistClusterer: this.getMarkerClusterer(map, 'does-not-exist'),
            othersClusterer: this.getMarkerClusterer(map, 'others'),
        }));
        setTimeout(() => {
            let boundInput = this.getBounds();
            this.setState({
                box: boundInput
            })
        }, 500)
    }

    handleChange = (e) => {
        if (e.value.end != null) {
            this.setState({
                dateStart: moment(e.value.start).format('yyyy-MM-DD hh:mm:ss'),
                dateEnd: moment(e.value.end).format('yyyy-MM-DD hh:mm:ss'),
                showDate: e.value,
            }, () => { this.handleFilterUpdate() })
        }
    }

    handleCleanDate = () => {
        this.setState({
            dateStart: null,
            dateEnd: null,
            showDate: {}
        }, () => { this.handleFilterUpdate() })
    }

    handleClearMapFilter = (updateFilteredMapData = true) => {
        const { setHighlightedPoles } = this.props.highlightedPolesContext;
        setHighlightedPoles([]); 

        this.setState({
            showClosed: true,
            showPulled: true,
            showReadyToGo: true,
            showHeavyVegetation: true,
            showPoleNotSet: true,
            showElectricPower: true,
            showPoleNeedsTopping: true,
            showNoAccess: true,
            showComplexTransfers: true,
            showDoesNotExist: true,
            showForeignOwned: true,
            showOthers: true,
            filteredMapData: [],
            currentSelectedPole: null,
        }, () => {
            if(updateFilteredMapData) {
                this.updateFilteredMapData('handleClearMapFilter');
            }
        });
    };

    handleGoToReport = () => {
        const { setSelectedTab } = this.props.tabContext;
        setSelectedTab(1);
        this.props.navigate('/report'); 

        this.setState({ currentSelectedPole: null });
    }

    handleFilterUpdate = () => {
        this.setState({
            loading: true
        })
        var rawQuery = "";
        var tempQuery = "";
        var tempQuery1 = "";
        var tempQuery2 = "";
        var tempQuery3 = "";
        var temparray = [];
        if (this.state.created_user.length > 0) {
            var tempString = this.state.created_user.map((value) => `${"'" + value + "'"}`).join(',');
            tempQuery = "created_user In (" + tempString + ")";
        }
        else {
            tempQuery = "";
        }

        if (this.state.Reject_Status.length > 0) {
            var tempString = this.state.Reject_Status.map((value) => `${value}`).join(',');
            tempQuery1 = "Reject_Status In (" + tempString + ")";
        }
        else {
            tempQuery1 = "";
        }

        if (this.state.dateEnd != null && this.state.dateStart != null) {
            var tempString = "created_date < '" + this.state.dateEnd + "' and created_date > '" + this.state.dateStart + "'";
            tempQuery2 = tempString;
        }
        else {
            tempQuery2 = "";
        }
        if (this.state.audit_childbox_audited) {
            tempQuery3 = 'audit_user is not null'
        }

        if (tempQuery !== "") {
            temparray.push(tempQuery);
        }
        if (tempQuery1 !== "") {
            temparray.push(tempQuery1);
        }
        if (tempQuery2 !== "") {
            temparray.push(tempQuery2);
        }
        if (tempQuery3 !== "") {
            temparray.push(tempQuery3);
        }
        var rawQuery = temparray.map((value) => `${value}`).join(' and ');
        this.populateMapData(rawQuery);
    }

    handleCondition = (condition) => {
        if (condition === "1") {
            return "Non Reject";
        }
        else if (condition === "2") {
            return "Non Restorable Reject";
        }
        else if (condition === "3") {
            return "Priority Non Restorable Reject";
        }
        else if (condition === "4") {
            return "Priority Restorable Reject";
        }
        else if (condition === "5") {
            return "Restorable Reject";
        }
    }

    assignPoleSymbologyColor = (pole) => {
        if (pole && pole.info && pole.info.Pole_Status) {
            switch (pole.info.Pole_Status) {
                case "Pulled":
                case "Closed":
                    return selectedBlueIcon;
                case "Ready to Go":
                    return selectedGreenIcon;
                case "Heavy Vegetation":
                case "Pole Not Set":
                case "Electric Power":
                case "Pole Needs Topping":
                case "No Access":
                    return selectedOrangeIcon;
                case "Complex Transfers":
                    return selectedYellowIcon;
                case "Foreign Owned":
                case "Does Not Exist":
                    return selectedRedIcon;
                default:
                    return selectedBlackIcon;
            }
        }
        return selectedBlackIcon;
    };

    
    handleWarningIconClick = () => {
        this.setState({
            showErrorMessage: !this.state.showErrorMessage,
        });
    }

    render() {
        const { highlightedPoles } = this.props.highlightedPolesContext;

        const legendWithoutFilterApplied = (
            <div className="pulse-map-legend-with-filter">
                <GridLayout
                    gap={{
                        rows: 6,
                        cols: 2,
                    }}
                >
                    <GridLayoutItem row={1} col={1} className="map-icon-layoutitem">
                        <img src={selectedBlueIcon} alt="Closed Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={1} col={2}>
                        <div className="legend-row">
                            Closed
                    <Checkbox
                        checked={this.state.showClosed}
                        className="legend-checkbox"
                        style={{ backgroundColor: this.state.showClosed ? "#1260CE" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                        onChange={(e) => {
                              const isChecked = e.syntheticEvent.target.checked;
                              this.setState(
                                  {
                                     showClosed: isChecked, showPulled: isChecked, currentSelectedPole: null, },
                                     this.updateFilteredMapData
                                  );
                            }}
                    />
                        </div>
                    </GridLayoutItem>
                    <GridLayoutItem row={2} col={1} className="map-icon-layoutitem">
                        <img src={selectedGreenIcon} alt="Ready to Go Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={2} col={2}>
                        <div className="legend-row">
                            Ready to Go
                    <Checkbox
                                checked={this.state.showReadyToGo}
                                style={{ backgroundColor: this.state.showReadyToGo ? "#20790A" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                className="legend-checkbox"
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showReadyToGo: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </div>
                    </GridLayoutItem>

                    <GridLayoutItem row={3} col={1} className="map-icon-layoutitem">
                        <img src={selectedOrangeIcon} alt="No Access Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={3} col={2}>
                        <div className="legend-row">
                            No Access
                    <Checkbox
                                checked={this.state.showNoAccess}
                                className="legend-checkbox"
                                style={{ backgroundColor: this.state.showNoAccess ? "#FF8000" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        {
                                            showHeavyVegetation: isChecked,
                                            showPoleNotSet: isChecked,
                                            showElectricPower: isChecked,
                                            showPoleNeedsTopping: isChecked,
                                            showNoAccess: isChecked,
                                            currentSelectedPole: null
                                        },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </div>
                    </GridLayoutItem>

                    <GridLayoutItem row={4} col={1} className="map-icon-layoutitem">
                        <img src={selectedYellowIcon} alt="Complex Transfers Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={4} col={2}>
                        <div className="legend-row">
                            Complex Transfers
                    <Checkbox
                                checked={this.state.showComplexTransfers}
                                style={{ backgroundColor: this.state.showComplexTransfers ? "#FFC517" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                className="legend-checkbox"
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showComplexTransfers: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </div>
                    </GridLayoutItem>

                    <GridLayoutItem row={5} col={1} className="map-icon-layoutitem">
                        <img src={selectedRedIcon} alt="Does Not Exist Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={5} col={2}>
                        <div className="legend-row">
                            Does Not Exist
                    <Checkbox
                                checked={this.state.showDoesNotExist}
                                style={{ backgroundColor: this.state.showDoesNotExist ? "#FF0000" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                className="legend-checkbox"
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showDoesNotExist: isChecked, showForeignOwned: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </div>
                    </GridLayoutItem>

                    <GridLayoutItem row={6} col={1} className="map-icon-layoutitem">
                        <img src={selectedBlackIcon} alt="Others" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={6} col={2}>
                        <div className="legend-row">
                            Others
                    <Checkbox
                                checked={this.state.showOthers}
                                style={{ backgroundColor: this.state.showOthers ? "#000000" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                className="legend-checkbox"
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showOthers: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </div>
                    </GridLayoutItem>
                </GridLayout>
                <GridLayout
                    cols={[
                        { width: 25 },
                    ]}
                    gap={{ rows: 3, cols: 4 }}
                >
                    <GridLayoutItem row={1} col={2} className="pulse-map-legend-grid">
                        <div className="legend-row">
                            Displayed pole count: {this.state.filteredMapData.length}
                        </div>
                    </GridLayoutItem>
                </GridLayout>
            </div>
        );

        const legendWithFilterApplied = (
            <div className="pulse-map-legend">
                <GridLayout
                    gap={{
                        rows: 6,
                        cols: 2,
                    }}
                >
                    <GridLayoutItem row={1} col={1} className="map-icon-layoutitem">
                        <img src={selectedBlueIcon} alt="Closed Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={1} col={2}>
                        <div className="legend-row">Closed</div>
                    </GridLayoutItem>

                    <GridLayoutItem row={2} col={1} className="map-icon-layoutitem">
                        <img src={selectedGreenIcon} alt="Ready to Go Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={2} col={2}>
                        <div className="legend-row">Ready to Go</div>
                    </GridLayoutItem>

                    <GridLayoutItem row={3} col={1} className="map-icon-layoutitem">
                        <img src={selectedOrangeIcon} alt="No Access Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={3} col={2}>
                        <div className="legend-row">No Access</div>
                    </GridLayoutItem>

                    <GridLayoutItem row={4} col={1} className="map-icon-layoutitem">
                        <img src={selectedYellowIcon} alt="Complex Transfers Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={4} col={2}>
                        <div className="legend-row">Complex Transfers</div>
                    </GridLayoutItem>

                    <GridLayoutItem row={5} col={1} className="map-icon-layoutitem">
                        <img src={selectedRedIcon} alt="Does Not Exist Pole" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={5} col={2}>
                        <div className="legend-row">Does Not Exist</div>
                    </GridLayoutItem>

                    <GridLayoutItem row={6} col={1} className="map-icon-layoutitem">
                        <img src={selectedBlackIcon} alt="Others" />
                    </GridLayoutItem>
                    <GridLayoutItem className="pulse-map-legend-grid" row={6} col={2}>
                        <div className="legend-row">Others</div>
                    </GridLayoutItem>
                </GridLayout>
                <GridLayout
                    cols={[
                        { width: 25 },
                    ]}
                    gap={{ rows: 3, cols: 4 }}
                >
                    <GridLayoutItem row={1} col={2} className="pulse-map-legend-grid">
                        <div className="legend-row">
                            Displayed pole count: {this.state.filteredMapData.length}
                        </div>
                    </GridLayoutItem>
                </GridLayout>
            </div>
        );

        return (
            <>
                {
                    this.state.loading
                        ?
                        <div className='nimbly2-map-loader'><img className='nimbly2-map-loader-gif' src={loadinggif} /><img className='nimbly2-map-loader-text' src={loadingtext} /></div> : null
                }
                <div className={this.state.loading ? "nimbly-map-loading" : "map-container"} >
                    <GoogleMap
                        mapContainerStyle={this.props.fullSizeMap ? containerStyleFullSize : containerStyle}
                        center={this.state.currentCenter}
                        zoom={this.state.zoomLevel}
                        // options={getMapOptions()}
                        onFail={error => console.error(error)}
                        onLoad={this.handleMapLoad}
                        onDragEnd={this.boundsCallBack}
                        onZoomChanged={this.boundsZoomCallBack}
                        options={{
                                        mapTypeControl: true,
                                        mapTypeControlOptions: {
                                            position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
                                        },
                                        fullscreenControl: true,
                                        fullscreenControlOptions: {
                                            position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
                                        }
                        }}
                    >
                        <div className="map-button-group">
                            <Button
                                onClick={() => this.handleClearMapFilter()}
                                className="map-button"
                            >
                                Reset Map Filter
                            </Button>
                            {highlightedPoles && highlightedPoles.length > 0 && (
                                <Button
                                    onClick={() => this.handleGoToReport()}
                                    className="map-button"
                                >
                                    Go to Report
                                </Button>
                            )}
                        </div>
                        <GridLayout gap={{
                                cols: 0,
                                row: 6
                            }}
                            className={highlightedPoles && highlightedPoles.length > 0 ? "pulse-map-searchbox-container-querymap" : "pulse-map-searchbox-container"}
                       >
                            <GridLayoutItem className="box rect" col={1} row={1}>
                                <DropDownList
                                    id="genre"
                                    className = "pulse-map-searchbox-dropdown"
                                    data={mapSearchOption}
                                    value={this.state.searchType}
                                    onChange={(e) => this.handleSearchTypeChange(e)}
                                    //defaultItem="Pole Number"
                                />
                            </GridLayoutItem>
                            <GridLayoutItem className="box" col={2} row={1}>
                                {this.state.searchType === "Pole Number" ?
                                    <input
                                        onKeyUp={(e) => this.handleKeyPress(e)}
                                        type="text"
                                        placeholder="Search Maps"
                                        className="pulse-map-searchbox-input"

                                    /> :
                                        <Autocomplete
                                            onLoad={this.onLoad}
                                            onPlaceChanged={this.onPlaceChanged}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Maps"
                                                className={this.state.addressValid ? "pulse-map-searchbox-input" : "pulse-map-searchbox-input pulse-map-searchbox-input-error"}
                                                //valid={this.state.addressValid}
                                                onKeyUp={(e) => this.handleAddressKeyPress(e)}
                                            />
                                        </Autocomplete>
                                }
                            </GridLayoutItem>
                            <GridLayoutItem className="box rect parent" col={3} row={1} >
                                {this.state.addressValid ? null :
                                    <span className="pulse-input-icon">
                                        <img
                                            src={validationIcon}
                                            alt="Warning"
                                            className="pulse-address-search-warning-icon"
                                            onMouseDown={(e) => e.target.style.transform = 'scale(0.9)'} // Visual feedback
                                            onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                                            onClick={() => this.handleWarningIconClick()}
                                        />
                                    </span>
                                }
                            </GridLayoutItem>

                            <GridLayoutItem className="box rect" col={1} row={2} colSpan={2}>
                                {
                                    this.state.showErrorMessage ?
                                        <div className="white-box" ref={this.wrapperRef} >
                                            <h2 className="box-header">Maps cannot find {this.state.searchEnteredAddress}.</h2>
                                            <p className="box-content">
                                                Make sure your search is spelled correctly.Try adding a city, state, or zip code.
                                            </p>
                                        </div> : null
                                }
                            </GridLayoutItem>
                        </GridLayout>
                        {this.state.isSearchByAddress ?
                            <MarkerF
                                key={this.state.currentCenter}
                                position={this.state.currentCenter}
                                icon={addressIcon}
                            >
                            </MarkerF> : null
                        }
                        {this.state.currentSelectedPole !== null ?
                            <InfoWindow
                                position={this.state.currentSelectedPole.coords}
                            >
                                <ExpandedPole key={this.state.currentSelectedPole.info.GlobalID}
                                    item={this.state.currentSelectedPole}
                                />
                            </InfoWindow> : null
                        }
                        <></>
                    </GoogleMap>
                    {
                        !this.state.loading && (
                            highlightedPoles && highlightedPoles.length > 0
                                ? legendWithFilterApplied
                                : legendWithoutFilterApplied
                        )
                    }
                </div>
            </>
        )
    }

    async populateMapData(rawQuery) {
        const { selectedProject, GCP_Project, Dataset_ID } = this.props.projectContext;
        const { environmentConfig } = this.props.environmentConfigContext;

        // Construct the payload for the backend
        const payload = {
            Dataset_ID: Dataset_ID,
            GCP_Project: GCP_Project,
            Project: selectedProject,
            Location: {
                ColumnName: "Coordinates", 
                TableName: "Location_Details", 
            },
            UniqueID: {
                ColumnName: "GlobalID", 
                TableName: "Poles",    
            },
            Category: {
                ColumnName: "Pole Status",
                TableName: "Poles",        
            },
            Search: {
                ColumnName: "Pole Number", 
                TableName: "Poles",        
            }
        };

        this.setState({ loading: true });

        fetch(`${process.env.REACT_APP_WEB_API_URL}/api-common/poles/GetBriefPoles`, {
            method: 'POST',
            headers: {
                'frontendenvironmentconfig': environmentConfig,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((data) => {
                //The first Pole loading is always slow, so lets get it out of the way
                fetch(`${process.env.REACT_APP_WEB_API_URL}/api-common/poles/PoleLookup`, {
                    method: 'POST',
                    headers: {
                        'frontendenvironmentconfig': environmentConfig,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        Dataset_ID: Dataset_ID,
                        GCP_Project: GCP_Project,
                        Project: selectedProject,
                        GlobalID: "WrongSoBreak"
                    }),
                });

                const markerList = data.map(pole => {
                    let arr = pole.Location.split("-");
                    if (arr.length === 2) {
                        let lat = Number(arr[0]);
                        let lng = -(Number(arr[1])); 
                        const markerData = {
                            coords: { lat, lng },
                            info: {
                                GlobalID: pole.GlobalID,
                                Pole_Status: pole.Category,
                                Pole_Number: pole.Search,
                            },
                            highlighted: this.props.highlightedPolesContext.highlightedPoles.includes(pole.GlobalID),
                        };
                        return {
                            ...markerData,
                            iconSymbol: this.assignPoleSymbologyColor(markerData),
                        };
                    }
                    return null; 
                }).filter(Boolean);
                this.setState({
                    mapData: markerList,
                    mapDataLoaded: true,
                    filteredMapData: [],
                    currentCenter: markerList[0] ?.coords || { lat: 0, lng: 0 },
                    counts: markerList.length,
                    loading: false,
                }, () => {
                    setTimeout(this.updateFilteredMapData, 500);
                });
            })
            .catch(() => this.setState({ loading: false }));
    }
}
export default withEnvironmentConfig(withProject(withHighlightedPoles(withTabContext(CSPoleMap))));